import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import Mandala from "../components/decor/Mandala";
import { Home as HomeIcon } from "lucide-react";

const NotFound = () => (
  <PageLayout>
    <section className="relative min-h-[70vh] flex items-center overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 animate-mandala-slow">
          <Mandala size={520} color="#D4AF37" opacity={0.3} />
        </div>
      </div>
      <div className="relative max-w-2xl mx-auto text-center px-4">
        <div className="overline text-[#B65A14] mb-4">Page not found</div>
        <div className="font-serif-display text-7xl text-[#B65A14]">404</div>
        <p className="mt-6 text-[#3B2A1A]/80 leading-relaxed">
          The page you are seeking has not manifested. Perhaps it was renamed, moved, or does not yet exist. Let us return you to the sanctum.
        </p>
        <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#B65A14] text-[#FBF7F0] px-6 py-3 text-sm font-semibold" data-testid="notfound-home">
          <HomeIcon className="w-4 h-4" /> Return home
        </Link>
      </div>
    </section>
  </PageLayout>
);

export default NotFound;
